import {
  PLAY_ROUTE,
  PAUSE_ROUTE,
  SET_CURRENT_POINT,
  CLEAR_PLAYER_DATA
} from '../actions/intelligenceTimeRangePlayerActions'

const initialState = {
  isPlay: false,
  routeLength: 0,
  routeDates: [],
  currentPointIndex: 0,
  currentPointDate: null
}

const intellegenceTimeRangePlayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLAY_ROUTE:
      return Object.assign(
        {},
        state,
        {
          isPlay: true
        }
      )
    case PAUSE_ROUTE:
      return Object.assign(
        {},
        state,
        {
          isPlay: false
        }
      )
    case SET_CURRENT_POINT:
      const {index, date} = action.payload
      return Object.assign(
        {},
        state,
        {
          currentPointIndex: index,
          currentPointDate: date
        }
      )
    case CLEAR_PLAYER_DATA:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default intellegenceTimeRangePlayerReducer